
/* SHIPPING */
export const GET_SHIPPING_LISTING = "GET_SHIPPING_LISTING";
export const GET_SHIPPING_LISTING_SUCCESS = "GET_SHIPPING_LISTING_SUCCESS";
export const GET_SHIPPING_LISTING_FAIL = "GET_SHIPPING_LISTING_FAIL";

export const GET_SHIPPING_DETAILS = "GET_SHIPPING_DETAILS";
export const GET_SHIPPING_DETAILS_SUCCESS = "GET_SHIPPING_DETAILS_SUCCESS";
export const GET_SHIPPING_DETAILS_FAIL = "GET_SHIPPING_DETAILS_FAIL";

export const ADD_SHIPPING = "ADD_SHIPPING";
export const ADD_SHIPPING_SUCCESS = "ADD_SHIPPING_SUCCESS";
export const ADD_SHIPPING_FAIL = "ADD_SHIPPING_FAIL";

export const UPDATE_SHIPPING = "UPDATE_SHIPPING";
export const UPDATE_SHIPPING_SUCCESS = "UPDATE_SHIPPING_SUCCESS";
export const UPDATE_SHIPPING_FAIL = "UPDATE_SHIPPING_FAIL";

export const DELETE_SHIPPING = "DELETE_SHIPPING";
export const DELETE_SHIPPING_SUCCESS = "DELETE_SHIPPING_SUCCESS";
export const DELETE_SHIPPING_FAIL = "DELETE_SHIPPING_FAIL";

export const EXPORT_SHIPPING = "EXPORT_SHIPPING";
export const EXPORT_SHIPPING_SUCCESS = "EXPORT_SHIPPING_SUCCESS";
export const EXPORT_SHIPPING_FAIL = "EXPORT_SHIPPING_FAIL";

export const RESET_SHIPPING_STATE = 'RESET_SHIPPING_STATE';
export const RESET_SHIPPING_ATTACHMENT_STATE = 'RESET_SHIPPING_ATTACHMENT_STATE';